import { sanitize } from 'dompurify';
import { DateTime } from 'luxon';
const urlPattern = /((?:(http|https|Http|Https|rtsp|Rtsp):\/\/(?:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,64}(?:\:(?:[a-zA-Z0-9\$\-\_\.\+\!\*\'\(\)\,\;\?\&\=]|(?:\%[a-fA-F0-9]{2})){1,25})?\@)?)?((?:(?:[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}\.)+(?:(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])|(?:biz|b[abdefghijmnorstvwyz])|(?:cat|com|coop|c[acdfghiklmnoruvxyz])|d[ejkmoz]|(?:edu|e[cegrstu])|f[ijkmor]|(?:gov|g[abdefghilmnpqrstuwy])|h[kmnrtu]|(?:info|int|i[delmnoqrst])|(?:jobs|j[emop])|k[eghimnrwyz]|l[abcikrstuvy]|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])|(?:name|net|n[acefgilopruz])|(?:org|om)|(?:pro|p[aefghklmnrstwy])|qa|r[eouw]|s[abcdeghijklmnortuvyz]|(?:tel|travel|t[cdfghjklmnoprtvwz])|u[agkmsyz]|v[aceginu]|w[fs]|y[etu]|z[amw]))|(?:(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}|[1-9][0-9]|[0-9])))(?:\:\d{1,5})?)(\/(?:(?:[a-zA-Z0-9\;\/\?\:\@\&\=\#\~\-\.\+\!\*\'\(\)\,\_])|(?:\%[a-fA-F0-9]{2}))*)?(?:\b|$)/gi;
const hostRegex = /^((http|https|ftp):\/\/)/;
export const studlyCase = (str) => {
    str = str.replace('_', ' ').replace('-', ' ');
    const r = new RegExp(/(?:^\w|[A-Z]|\b\w|\s+)/g);
    const n = str.replace(r, (x, y) => {
        if (+x === 0) {
            return '';
        }
        const z = y === 0 ? x.toUpperCase() : x.toUpperCase();
        return z;
    });
    return n;
};
/**
 * Uppercase the first character of each word in a string.
 *
 * @example the quick fox => The Quick Fox
 *
 * @param str
 */
export const ucwords = (str) => {
    return (str + '').replace(/^(.)|\s+(.)/g, function ($1) {
        return $1.toUpperCase();
    });
};
/**
 * Uppercase the first character of a string.
 *
 * @example the quick fox => The quick fox
 *
 * @param str
 */
export const ucstring = (str) => {
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
};
export const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
};
export const hex2rgba = (hex, opacity) => {
    let h = hex.replace('#', '');
    h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));
    for (let i = 0; i < h.length; i++) {
        h[i] = parseInt(h[i].length == 1 ? h[i] + h[i] : h[i], 16);
    }
    if (typeof opacity != 'undefined') {
        h.push(opacity);
    }
    return 'rgba(' + h.join(',') + ')';
};
export const avatarHtml = (imageUrl) => {
    return `<img class="avatar avatar-small" src="${imageUrl}">`;
};
export const colorHtml = (colorHex) => {
    return `<span class="roomColor" style="background-color: ${colorHex}"></span>`;
};
export const activeHtml = (value) => {
    return `<span class="activeItem"><i class="material-icons activeItem">beenhere</i>${value}</span>`;
};
export const iconToHtml = (iconString) => {
    return `<i aria-hidden="true" class="icon material-icons" style="font-size: 16px;">${iconString}</i>`;
};
export const formatDate = (date, luxonFormat = 'dd-LL-yyyy') => {
    return DateTime.fromSQL(date).toFormat(luxonFormat);
};
export const formatDateTime = (date, luxonFormat = 'yyyy-LL-dd HH:mm:ss') => {
    return formatDate(date, luxonFormat);
};
export const trim = (char, str) => {
    // Make str regex safe.
    char = char.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    return str.replace(`/^[${char}]+|[${char}]+$/g`, '');
};
export const clearWhiteSpace = (str) => {
    if (/\s/.test(str)) {
        return str.replace(/\s/g, '');
    }
    return str;
};
export const sanitizeString = (value, allowHtml = false) => {
    return sanitize(value, { USE_PROFILES: { html: allowHtml } });
};
export const ratingStarHtml = (size = 16) => {
    return `<i aria-hidden="true" class="icon material-icons star-icon" style="font-size: ${size}px; color: #f8c623; height: ${size}px; width: ${size}px;">star</i>`;
};
/**
 * Replace the urls in a piece of text with anchors tags
 *
 * @example this is link www.google.com =>
 * this is link <a href="https://www.google.com" target="_blank" rel="noopener noreferrer">www.google.com</a>
 *
 * @param {string} text
 */
export const replaceUrlsWithAnchorTags = (text) => {
    const parsedText = text.replace(urlPattern, (url) => {
        const parsedUrl = hostRegex.test(url) ? url : `https://${url}`;
        return `<a class="chat-link" target="_blank" href="${parsedUrl}">${url}</a>`;
    });
    return sanitizeString(parsedText, true);
};
export const generateUuid = () => {
    const s = [];
    const hexDigits = '0123456789abcdef';
    for (let i = 0; i < 36; i += 1) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((Number(s[19]) & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-';
    const uuid = s.join('');
    return uuid;
};
